import { MoovStepPremierServiceConfigurationDTO } from "./moovStepPremierServiceConfigurationDTO";

export class MoovStepConfigurationDTO{
    public id?:number;
    public delayBy?:number;
    public approveBy?:number;
    public outputOverrides?:string;
    public filterOverrides?:string;
    public allocationOverrides?:string;
    public validationOverrides?:string;
    public parameterOptionId?:number;
    public parameters?:string;
    public moovConfigurationId!:number;
    public moovStepId!:number;
    public premierServiceConfigurations?:MoovStepPremierServiceConfigurationDTO[];
    public skipIfNoData:boolean=false;
    public skipAlways:boolean=false;
}